// Momentjs isoWeekday mapping values
export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;
export const SUNDAY = 7;



// WEBPACK FOOTER //
// ./src/constants/weekDays.js